export const slab_url: string = "slab";